<template>
  <div id="delivery-man-detail" v-visibility-change="visibilityChange">
    <!-- Status text -->
    <div class="basic1-text">
      {{ statusMessage }}
    </div>
    <!-- Progress bar -->
    <order-status-bar :status-level="order.customIndicators.statusLevel" :progress-color="progressColor" />
    <!-- Driver detail -->
    <div v-if="showDetailDriver" class="basic1-driver-container">
       <el-divider />
      <el-row :gutter="24" class="mt-10">
        <el-col :span="5">
          <avatar-interface :src="driverPhoto" :size="size" class="mr-16" />
        </el-col>
        <el-col :span="15">
          <el-row>
            <el-col :span="24" class="mt-15">
              <transition name="fade" mode="out-in">
                <span class="display-block basic1-driver-fullname">
                  {{ driverName | toLowerCase }}
                </span>
              </transition>
            </el-col>
            <el-col v-if="isOnSiteCountDown" justify="end" :span="8">
              <h2 class="folio-eta-label">
                {{ countDown.time }}
              </h2>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <span class="basic1-driver-description">
                {{ $t('general.driver') }}
              </span>
            </el-col>
            <el-col v-if="false" :span="8">
              <span class="display-block folio-description">
                {{ folio }}
              </span>
            </el-col>
            <el-col v-if="isETAAlerts" :span="16">
              <span class="mt-10 display-block folio-eta-description">
                {{ ETAAlertIndicator.message }}
              </span>
            </el-col>
            <el-col v-if="isOnSiteCountDown" :span="16">
              <span class="mt-10 display-block folio-eta-description">
                {{ countDown.message }}
              </span>
            </el-col>
          </el-row>
        </el-col>
        <div v-if="isPhone" class="basic1-phone-icons">
          <el-col :span="2">
            <a :href="`tel:${isPhone}`" target="_blank">
              <PhoneIcon />
            </a>
          </el-col>
          <el-col :span="2">
            <a :href="`sms:${isPhone}`" target="_blank">
              <MessageIcon />
            </a>
          </el-col>
        </div>
        <el-col v-if="waPhone" :span="4">
          <a :href="`https://wa.me/${waPhone}`" target="_blank">
            <img src="@/assets/images/wa.png" class="icon-wa">
          </a>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
// Components
import OrderStatusBar from '@/components/utils/stepper'

// svg
import PhoneIcon from '@/assets/images/svg/templates/basic1/ic-phone.svg'
import MessageIcon from '@/assets/images/svg/templates/basic1/ic-msg.svg'

// Mixins
import DeliveryDetailMethods from '@/utils/mixins/deliveryDetailMethods'

export default {
  name: 'DeliveryManDetailBasic1',
  mixins: [DeliveryDetailMethods],
  components: {
    OrderStatusBar,
    PhoneIcon,
    MessageIcon
  },
  props: {
    statusMessage: {
      type: String,
      default: ''
    },
    showDetailDriver: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    driverName: function() {
      let _driver = ''
      if (this.order.thirdPartyData && this.order.thirdPartyData.driver && this.order.thirdPartyData.driver.name) {
        _driver = this.order.thirdPartyData.driver.name
      } else if (this.order.deliveryMan && this.order.deliveryMan.fullName) {
        _driver = this.order.deliveryMan.fullName
      }
      return _driver
    },
    isPhone: function() {
      let _phone = null
      if (this.order.thirdPartyData && this.order.thirdPartyData.driver && this.order.thirdPartyData.driver.phone) {
        _phone = this.order.thirdPartyData.driver.phone
      } else if (this.order.deliveryMan && this.order.deliveryMan.phone && this.order.deliveryMan.phone.countryCode && this.order.deliveryMan.phone.phone) {
        _phone = `${this.order.deliveryMan.phone.countryCode}${this.order.deliveryMan.phone.phone}`
      }
      return _phone
    }
  }
}
</script>

